/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ConfiguratorImport } from './routes/_configurator'
import { Route as IndexImport } from './routes/index'
import { Route as ConfiguratorStep4Import } from './routes/_configurator/step-4'
import { Route as ConfiguratorStep3Import } from './routes/_configurator/step-3'
import { Route as ConfiguratorStep2Import } from './routes/_configurator/step-2'
import { Route as ConfiguratorStep1Import } from './routes/_configurator/step-1'

// Create/Update Routes

const ConfiguratorRoute = ConfiguratorImport.update({
  id: '/_configurator',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ConfiguratorStep4Route = ConfiguratorStep4Import.update({
  path: '/step-4',
  getParentRoute: () => ConfiguratorRoute,
} as any)

const ConfiguratorStep3Route = ConfiguratorStep3Import.update({
  path: '/step-3',
  getParentRoute: () => ConfiguratorRoute,
} as any)

const ConfiguratorStep2Route = ConfiguratorStep2Import.update({
  path: '/step-2',
  getParentRoute: () => ConfiguratorRoute,
} as any)

const ConfiguratorStep1Route = ConfiguratorStep1Import.update({
  path: '/step-1',
  getParentRoute: () => ConfiguratorRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_configurator': {
      id: '/_configurator'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ConfiguratorImport
      parentRoute: typeof rootRoute
    }
    '/_configurator/step-1': {
      id: '/_configurator/step-1'
      path: '/step-1'
      fullPath: '/step-1'
      preLoaderRoute: typeof ConfiguratorStep1Import
      parentRoute: typeof ConfiguratorImport
    }
    '/_configurator/step-2': {
      id: '/_configurator/step-2'
      path: '/step-2'
      fullPath: '/step-2'
      preLoaderRoute: typeof ConfiguratorStep2Import
      parentRoute: typeof ConfiguratorImport
    }
    '/_configurator/step-3': {
      id: '/_configurator/step-3'
      path: '/step-3'
      fullPath: '/step-3'
      preLoaderRoute: typeof ConfiguratorStep3Import
      parentRoute: typeof ConfiguratorImport
    }
    '/_configurator/step-4': {
      id: '/_configurator/step-4'
      path: '/step-4'
      fullPath: '/step-4'
      preLoaderRoute: typeof ConfiguratorStep4Import
      parentRoute: typeof ConfiguratorImport
    }
  }
}

// Create and export the route tree

interface ConfiguratorRouteChildren {
  ConfiguratorStep1Route: typeof ConfiguratorStep1Route
  ConfiguratorStep2Route: typeof ConfiguratorStep2Route
  ConfiguratorStep3Route: typeof ConfiguratorStep3Route
  ConfiguratorStep4Route: typeof ConfiguratorStep4Route
}

const ConfiguratorRouteChildren: ConfiguratorRouteChildren = {
  ConfiguratorStep1Route: ConfiguratorStep1Route,
  ConfiguratorStep2Route: ConfiguratorStep2Route,
  ConfiguratorStep3Route: ConfiguratorStep3Route,
  ConfiguratorStep4Route: ConfiguratorStep4Route,
}

const ConfiguratorRouteWithChildren = ConfiguratorRoute._addFileChildren(
  ConfiguratorRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ConfiguratorRouteWithChildren
  '/step-1': typeof ConfiguratorStep1Route
  '/step-2': typeof ConfiguratorStep2Route
  '/step-3': typeof ConfiguratorStep3Route
  '/step-4': typeof ConfiguratorStep4Route
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ConfiguratorRouteWithChildren
  '/step-1': typeof ConfiguratorStep1Route
  '/step-2': typeof ConfiguratorStep2Route
  '/step-3': typeof ConfiguratorStep3Route
  '/step-4': typeof ConfiguratorStep4Route
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_configurator': typeof ConfiguratorRouteWithChildren
  '/_configurator/step-1': typeof ConfiguratorStep1Route
  '/_configurator/step-2': typeof ConfiguratorStep2Route
  '/_configurator/step-3': typeof ConfiguratorStep3Route
  '/_configurator/step-4': typeof ConfiguratorStep4Route
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '' | '/step-1' | '/step-2' | '/step-3' | '/step-4'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '' | '/step-1' | '/step-2' | '/step-3' | '/step-4'
  id:
    | '__root__'
    | '/'
    | '/_configurator'
    | '/_configurator/step-1'
    | '/_configurator/step-2'
    | '/_configurator/step-3'
    | '/_configurator/step-4'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfiguratorRoute: typeof ConfiguratorRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfiguratorRoute: ConfiguratorRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_configurator"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_configurator": {
      "filePath": "_configurator.tsx",
      "children": [
        "/_configurator/step-1",
        "/_configurator/step-2",
        "/_configurator/step-3",
        "/_configurator/step-4"
      ]
    },
    "/_configurator/step-1": {
      "filePath": "_configurator/step-1.tsx",
      "parent": "/_configurator"
    },
    "/_configurator/step-2": {
      "filePath": "_configurator/step-2.tsx",
      "parent": "/_configurator"
    },
    "/_configurator/step-3": {
      "filePath": "_configurator/step-3.tsx",
      "parent": "/_configurator"
    },
    "/_configurator/step-4": {
      "filePath": "_configurator/step-4.tsx",
      "parent": "/_configurator"
    }
  }
}
ROUTE_MANIFEST_END */
